module.exports = __webpack_public_path__ + "img/68_Liturghii_Ramnic_1733.ebf1f476.jpg";